import useFetch from '@hooks/useFetch';
import { useRouter } from 'next/router';
import useCompete from '@stores/compete';
import { emptyObject } from '@constants/empty';
import keepPreviousResult from '@api/hooks/middleware/keepPreviousResult';

const DEFAULT_TIME_PERIOD = 30;

const useRatingProgressInfo = () => {
  const { query } = useRouter();
  const { goalUID } = query;
  const { selectedDuration } = useCompete();

  const getKey = () => {
    if (goalUID) {
      return `odin/v1/compete/rating/?goal_uid=${goalUID}&time_period=${
        selectedDuration || DEFAULT_TIME_PERIOD
      }&activity=true`;
    }
    return null;
  };

  const { data, isLoading, mutate } = useFetch(
    getKey(),
    {},
    { use: [keepPreviousResult], revalidateOnMount: true }
  );

  return { data: data || emptyObject, isLoading, mutate };
};
export default useRatingProgressInfo;
